<template>
    <div class="user dropdown-menu text-center" >
           <v-menu
            transition="expand-x-transition"
            nudge-bottom="50"
            :left='$vuetify.rtl'
            min-width="60"
            dark
            offset-x
            class="ml-2 mr-2"
          >
            <template v-slot:activator="{ on, attrs }">
               <v-avatar  v-bind="attrs"
                v-on="on" left size="48" style="cursor:pointer" >
                <v-img :src="imgSrc"  alt="user profile image">
                <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
                </v-img>
           </v-avatar>
            </template>
            <v-list>
              <v-list-item 
               v-for="(link,index) in links" :key="index"
              link :to="link.to" exact
              >
                <v-list-item-icon>
                <v-icon>{{link.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-capitalize font-weight-medium">
                 {{$t(link.title)}}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
         </div>
</template>

<script>
import {userAvatar} from '@/mixins/index'
export default {
    data() {
        return {
            links:[
              {
                 to:'/account',
                 title:'navbare.dropDownMenu.MyAccount',
                 icon:'fa fa-user'
              },
              {
                 to:'/myOrders',
                 title:'navbare.dropDownMenu.MyOrders',
                 icon:'fa fa-cart-arrow-down'
              }
            ]
        }
    },
    mixins:[userAvatar],
    created(){
      this.getuserAvatar(this.$store.state.User.avatar,this.$store.state.User.proveId)
    }
}
</script>

<style lang="scss" scoped>
    
   
</style>